module.exports = __webpack_public_path__ + "media/images/nav_social/nav_youtube-4912167f109c0e99a1f9a486f4220fdc.svg";